import React, {useState, useEffect} from 'react';
import {useParams} from 'react-router'
import '../styling/containerStyles.css'
import VerifyNumber from './verifyNumber'
import VerifyOtp from './verifyOtp'
import CustomerDetails from './customerDetails'
import TransactionDetails from './transactionDetails'
import BankDetails from './bankDetails'
import Success from './successTransaction'
import Footer from '../components/footer'
import CircularProgress from '@material-ui/core/CircularProgress'
import Payouts from '../container/paytmPayout'
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import ErrorMessage from './errorMessage';
import ImageUploadPage from './imageUpload';
import OnfidoPageptr from './onfidoPageptr';
import WarningModal from '../components/modal'
import TransactionHistoryFilter from './transationHistoryFilter';

interface MainProps{
  banner: any,
  subBanner: any,
}

interface TransactionHistoryData {
  redeem_amount: string,
  createddate: string
}
interface LimitInfo {
  remaining_attempts: number;
  remaining_amount: number;
}

export interface MaxCountResponse {
  max: number;
  [brand: string]: LimitInfo | number;
}

let cancel: any;

export const Main: React.FC<MainProps> = (props: MainProps) =>{

    const [phoneNo, setPhoneNo] = useState('')
    const [codeScanStatus, setCodeScanStatus] = useState(true)
    const [isVerified, setIsVerified] = useState(false) 
    const [isOtpVerified, setIsOtpVerified] = useState(false)
    const [isNewUser, setIsNewUser] = useState(true) 
    const [newUser, setNewUser] = useState(true) 
    const [isProceeded, setIsProceeded] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)
    const [loading, setLoading] = useState(false)
    const [amount, setAmount] = useState('')
    const [paymentType, setPaymentType] = useState('')
    const [paymentStatus, setPaymentStatus] = useState('')
    const [accNo, setAccNo] = useState('')
    const [ifsc, setIfsc] = useState('')
    const [bankDetailsSet, setBankDetailsSet] = useState(false)
    const [membershipID, setMembershipID] = useState('')
    const [redeemable, setRedeemable] = useState(false)
    const [paymentMessage, setPaymentMessage] = useState('')
    const [msgPh, setMsgPh] = useState('')
    const [bankMsg, setBankMsg] = useState('')
    const [transactions, setTransactions] = useState('')
    const [conversions, setConversions] = useState(['', '', ''])
    const [confirmedPayStatus, setConfirmedPayStatus] = useState(false)
    const [orderID, setOrderID] = useState('')
    const [razorID, setRazorID] = useState('')
    const [canRedeem, setCanRedeem] = useState(true)
    const [couponValid, setInvalidCoupon] = useState(false)
    const [otpMessage, setOtpMessage] = useState('')
    const [failUnbind, setFailUnbind] = useState('')
    const [transactionLoading, setTransactionLoading] = useState(false)
    const [countCheck, setCount] = useState(true)
    const [previousBankDetails, setPreviousBankDetails] = useState('')
    const [previousBankDetailsFlag, setPreviousBankDetailsFlag] = useState(false)
    const [prevBankType, setPreviousBankType] = useState(false)
    const [prevBankUUID, setPreviousBankUUID] = useState(['', ''])
    const [bindCodeData, setBindCodeData] = useState(null)
    const [locationData, setLocationData] = useState({
      lat : 0,
      long : 0,
      city : '',
      pincode : ''
    })
    const [isAmountZero, setIsAmountZero] = useState(false)
    const [is0Point, setIs0Point] = useState(false)
    const [codeScanStatusCode, setCodeScanStatusCode] = useState('')


    // Added for IDFY
    const [getFile, setGetFile] = useState('');
    const [docUploadFlag, setDocUploadFlag] = useState('');
    const [idfyDocData, setIdfyDocData] = useState('');
    const [skipStatus, setSkipStatus] = useState('');
    const [idfyTranStatus, setIdfyTranStatus] = useState('');
    const [docUploadLoading, setDocUploadLoading] = useState(false);
    const [idfyCountCheck, setIdfyCount] = useState(true);
    const [kycMessageVerified, setKycMessageVerified] = useState('');
    const [kycDocStatus, setKycDocStatus] = useState('');
    const [isSelfiePage, setIsSelfiePage] = useState(false);
    const [getSelfie, setSelfieFile] = useState('');
    const [selfieDocStatus, setSelfieDocStatus] = useState('');
    const [isOnfidoPage, setIsOnfidoPage] = useState(false)
    const [RejectKYC, setRejectKYC] = useState(false);
    const [KycStatus, setKycStatus] = useState('');
    const [KycStatusAttempt, setKycStatusAttempt] = useState(0);
    const [validateUser, setValidateUser] = useState(false);
    const [faceLiveMessage, setFaceLiveMessage] = useState('')
    // end here

    // Added for fetch pincode to pass in check reedemability
    const [pincode, setPincode] = useState('')
    const [locationBlocked, setLocationBlocked] = useState(false)
    // end here

    //TRANSACTION HISTORY START HERE
    const [viewHistory, setViewHistory] = useState(false);
    const [transactionHistoryData, setTransactionHistoryData] = useState<TransactionHistoryData>();
    const [transactionTab, setTransactionTab] = useState('ALL');
    const [transactionHistoryLoading, setTransactionHistoryLoading] = useState(false);
    const [hasMoreTransactions, setHasMoreTransactions] = useState(false);
    const [loadingMoreTransactions, setLoadingMoreTransactions] = useState(false);
    const [transactionOffset, setTransactionOffset] = useState(0);
    const [coupons, setCoupons] = useState<Array<{ code: string; amount: string, brand?: string }>>([]);
    const [isMultiScan, setIsMultiScan] = useState(false);
    const [multiScanResults, setMultiScanResults] = useState<
      Array<{ coupon: string; status: string; message: string; orderId?: string; razor_transaction_id?: string, amount?: string }>
    >([]);
    //TRANSACTION HISTORY END HERE

    // Added for get max limit counts
    const [maxLimitCounts, setMaxLimitCounts] = useState<MaxCountResponse>({ max: 0 });
    let interval : any;

    const HOST = process.env.REACT_APP_HOST; 
    const API = process.env.REACT_APP_API;

    const path = window.location.pathname;
    const pathParams = path.split('/')

    const refresh_error_msg = 'Token is invalid or expired';
    let count = 0; 
    
    let hostName = window.location.hostname.split('.')[0]
    let userType = ''


    // When need to run in local
    if(hostName === 'localhost'){
      hostName = 'saathirewards'
    }

    if(hostName === 'saathirewards-uat'){
      hostName = 'saathirewards'
    }

    if(hostName === 'saathirewards'){
      userType = 'FCC'
    }
    else if(hostName === 'saathirewardsuat'){
      userType = 'FCC'
    }
    else if(hostName === 'cwcinstantrewards'){
      userType = 'CWC'
    }
    else if(hostName === 'paytm-instant-rewards'){
      userType = 'CWC'
    }
    else if(hostName === 'saathirewards-uat'){
      userType = 'FCC'
    }
    interface ParamTypes {
      couponId: string,
    }

    const couponCode = useParams<ParamTypes>().couponId
    
    const axios = require('axios').default;
    const CancelToken: any = axios.CancelToken;

    const resetAll = (couponUnbind: boolean) => {
        
        setIsOtpVerified(false)
        setIsVerified(false)
        setIsProceeded(false)
        setIsSuccess(false)
        setIsNewUser(true)
        setCoupons([]);
        setIsMultiScan(false);
        setMultiScanResults([]);
    }

    const resetWhileLogoutAll = (couponUnbind: boolean) => {
      setIsOtpVerified(true)
      setIsProceeded(false)
  }

    useEffect(() => {
      checkCode();
      if(localStorage.getItem("IS_LOGIN") === "yes") {
        resetWhileLogoutAll(true);
      }
    }, [])

    useEffect(() => {
      if (membershipID) {
        handleToGetMaxLimitCounts(membershipID);
      }
    }, [membershipID])

  const getLocn = async () => {
    return new Promise((resolve, reject) => {
      // Check for geolocation permission status
      navigator.permissions.query({ name: 'geolocation' }).then((result) => {
        if (result.state === 'denied') {
          setLocationBlocked(true);
          reject("Location access denied by user.");
          return;
        }

        // If permission not denied, get current position
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            const geocoder = new google.maps.Geocoder();
            const latlng = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);

            geocoder.geocode({ location: latlng }, (results, status) => {
              if (status === google.maps.GeocoderStatus.OK && results[0]) {
                for (let j = 0; j < results[0].address_components.length; j++) {
                  const component = results[0].address_components[j];
                  if (component.types.includes('postal_code')) {
                    const pincode = component.long_name;
                    setPincode(pincode);  // update UI state
                    resolve(pincode);    // return pincode
                    return;
                  }
                }
                reject("Postal code not found.");
              } else {
                reject("Geocoder failed: " + status);
              }
            });
          },
          (error) => {
            reject("Geolocation error: " + error.message);
          }
        );
      });
    });
  }

    const validateUserCmdi = async () => {
      setLoading(true)
      return axios
        .get(
          `${HOST}apis/v.1.0/instantrewards/${membershipID}/validate-user-cmdi-type/`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')
            }
          }
        )
        .then(async(res: any) => {
          const data = res.data;
          setLoading(false)          
          // setValidateUser(data.is_instantrewards_user)
          setValidateUser(true);
          // if(data.is_instantrewards_user === true) {
            await checKYCStatus();
            await documentIdfyStatus(membershipID, '');
          // }
          return res;
        })
        .catch((error: any) => {
          setLoading(false)
          return error
        });
    }

    const checKYCStatus = async () => {
      setLoading(true)
      return axios
        .get(
          `${HOST}apis/v.1.0/haisha-contractor/${localStorage.getItem("phone_number")}/check-kyc-required/`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')
            }
          }
        )
        .then((res: any) => {
          const data = res.data;
          setLoading(false)          
          setSkipStatus(data.is_kyc_required)
          setIsOnfidoPage(true);
          return res;
        })
        .catch((error: any) => {
          setLoading(false)
          return error
        });
    }

    // Reusable function to check coupon code - can be passed as prop to child components
    const checkCouponCode = async (code: string) => {
      try {
        const response = await axios.post(
          `${HOST}${API}check-coupon-code/`,
          {
            code: code,
            user: userType
          },
          {
            headers: {
              'Content-Type': 'application/json',
            }
          }
        );
        
        const data = response.data.data;
        
        if (data.resultCode === 0) {
          // Code is valid
          return { valid: true, data: data };
        } else {
          // Code is invalid
          return { valid: false, message: data.resultDescription || 'Invalid coupon code' };
        }
      } catch (err) {
        const errorData = (err as any).response?.data;
        let errorMsg = 'Invalid coupon code. Please try again.';
        
        // Handle different error response formats
        if (errorData) {
          if (errorData.message) {
            errorMsg = errorData.message;
          } else if (errorData.resultDescription) {
            errorMsg = errorData.resultDescription;
          } else if (errorData.data?.resultDescription) {
            errorMsg = errorData.data.resultDescription;
          }
        }
        
        return { valid: false, message: errorMsg };
      }
    };

    const checkCode = async() => {
      return axios
      .post(
        `${HOST}${API}check-coupon-code/`,
        {
          code: couponCode,
          user: userType
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      )
      .then((res: any) => {
        const data = res.data.data
        if(data.resultCode === 0){
          setAmount(data.codePoint)
          if(data.codePoint == '0.00'){
            setIs0Point(true)
          }
          if(localStorage.getItem("IS_LOGIN") === "yes") {
            handleToUpdateOTP("");
          }
        }
        else{
          setCodeScanStatusCode(data.resultCode)
          setInvalidCoupon(true)
          setCodeScanStatus(false)
          setIsOtpVerified(false)
          setIsVerified(false)
        }
        return data;
      })
      .catch((err: any) => {
        const amtInvalid = err.response.data;
        if(amtInvalid.amount_invalid === true) {
          handleToUpdateStatus('AMOUNTINVALID', amtInvalid.message, '-', '-')
        }
        if(amtInvalid.user_blocked === true) {
          handleToUpdateStatus('BLOCKUSER', amtInvalid.message, '-', '-')
        }
          setCodeScanStatusCode(amtInvalid.resultCode)
          setCodeScanStatus(false)
          setIsOtpVerified(false)
          setIsVerified(false)
          return err;
      });
    }

    const handleToUpdateNumber= async (arg: any) => {
      if(codeScanStatus === true){
        setLoading(true)
        setPhoneNo(arg)
        let data = {phone_number: arg, app_name: 'paytm', paytm_user_type: userType}

        const settings = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            }
          };
          try {
            const checkCodeResponse = await checkCode()                 
            if(checkCodeResponse.resultCode === 0){
              setAmount(checkCodeResponse.codePoint)
              if(localStorage.getItem("IS_LOGIN") === "yes") {
                // resetWhileLogoutAll(true);
                // redemption();
                handleToUpdateOTP("");
              }
              const fetchResponse = await fetch(`${HOST}${API}login/get-otp/`, settings);
              if(fetchResponse.status === 200){
                localStorage.setItem('phone_number', arg)
                setIsVerified(true)
              }
              else{
                setMsgPh('Something went wrong')
              }
            }
            else{
              setCodeScanStatusCode(checkCodeResponse.resultCode)
              setInvalidCoupon(true)
              setCodeScanStatus(false)
              setIsOtpVerified(false)
              setIsVerified(false)
            }
            
          } catch (e) {
            setMsgPh('Something went wrong')
          }
        setLoading(false)
        }       
    }
    
    const getTokenPair = (phoneNumber: any, otp: any) => {
        return axios
          .post(
            `${HOST}${API}login/token-access/`, 
            {
              phone_number: phoneNumber,
              otp: otp,
              app_name: 'paytm'
            },
            {
              headers: {
                'Content-Type': 'application/json',
              }
            }
          )
          .then((res: any) => {
            localStorage.setItem('IS_LOGIN', "yes")
            return res;
          })
          .catch((err: any) => {
            return err;
          });
    };

    const redemption = async() =>{ 
      setLoading(true)
      const pincodeResponse = await getLocn();
      return axios
          .post(
            `${HOST}${API}check-redeemability/`, 
            {
              phone_number: localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNo,
              division: userType,
              product : pathParams[1],
              pincode: pincodeResponse,
              code: couponCode
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('x-access-token')
              }
            }
          )
          .then((res: any) => {
            setLoading(false)
            return res;
          })
          .catch((err: any) => {
            const memberValidation = err.response.data;
            if(memberValidation.user_can_order === true) {
              handleToUpdateStatus('MEMBERINVALID', memberValidation.message, '-' , '-');
            }
            setLoading(false)
            return err;
          });
    }

    const refresh_access_token = async (res: any) => {
        return axios
          .post(
            `${HOST}${API}login/token-refresh/`, 
            {
              refresh: localStorage.getItem('x-refresh-token')
            },
            {
              headers: {
                'Content-Type': 'application/json',       
              }
            }
          )
          .then((res: any) => {
              if(res.status === 200){
                localStorage.setItem('x-access-token', 'Token ' + res.data['access'])
              }
              else{
                setMsgPh('something went wrong')
                setIsVerified(false)
              }
            })
          .catch((err: any) => {
            setMsgPh('something went wrong')
            setIsVerified(false)
          });
    }

    const handleToUpdateOTP = async (arg: any) => {
        if(arg === 'GoBack'){
            setIsVerified(false)
        }
        else {
          if(!localStorage.getItem("IS_LOGIN")){
            setLoading(true)
          
          
          if(newUser === false){
            setIsNewUser(false)
          }
        }          
          try {
            if(localStorage.getItem("IS_LOGIN") === "yes") {
              const redemptionResponse = await redemption() 
              const response = redemptionResponse.data.data
              if(response.redeemable === false){
                setPaymentStatus('NOT POSSIBLE')
                if(response.user_type === "BDE") {
                  setPaymentMessage("You are a registered customer of Pidilite")
                }
                else {
                  setPaymentMessage("You are a " + response.user_type)
                }
                setIsSuccess(true)
                setCanRedeem(false)
              }
              else{
                setIsOtpVerified(true)
                if(response.user_type !== "NEW USER"){
                  setIsNewUser(false)
                  setNewUser(false)
                  setMembershipID(response.membership_id)
                }
                if(response.redemption_options.POINTS === true){
                  setRedeemable(true)
                }
                const factor = response.conversion
                setConversions([factor.Wallet, factor.Bank, factor.Points, factor.PtoR])
              }

            }
            else {
            const fetchResponse = await getTokenPair(phoneNo, arg)
            const status = fetchResponse.status
            if(status === 200){
                const headers = fetchResponse.headers
                localStorage.setItem('x-access-token', 'Token ' + headers['x-access-token'])
                localStorage.setItem('x-refresh-token', 'Token ' + headers['x-refresh-token'])

                const redemptionResponse = await redemption() 
                const response = redemptionResponse.data.data
                if(response.redeemable === false){
                  setPaymentStatus('NOT POSSIBLE')
                  if(response.user_type === "BDE") {
                    setPaymentMessage("You are a registered customer of Pidilite")
                  }
                  else {
                    setPaymentMessage("You are a " + response.user_type)
                  }
                  setIsSuccess(true)
                  setCanRedeem(false)
                }
                else{
                  setIsOtpVerified(true)
                  if(response.user_type !== "NEW USER"){
                    setIsNewUser(false)
                    setNewUser(false)
                    setMembershipID(response.membership_id)
                  }
                  if(response.redemption_options.POINTS === true){
                    setRedeemable(true)
                  }
                  const factor = response.conversion
                  setConversions([factor.Wallet, factor.Bank, factor.Points, factor.PtoR])
                }

            }
            else{
              const errMessageOTP = fetchResponse.response.data;
                // setOtpMessage('Invalid OTP')
                setOtpMessage(errMessageOTP.message.otp)
            }
          }
          } catch (e) {
            setIsVerified(false)
            setMsgPh('Something went wrong')
          } 
          setLoading(false)
        }
    };

    const handleToUpdateAddDetails = (arg: any) => {
      
      let getLocationData = {
        lat : arg.lat ? arg.lat : 0,
        long : arg.long ? arg.long : 0,
        city : arg.city ? arg.city : '',
        pincode : arg.pincode ? arg.pincode : ''
      }
      setLocationData(getLocationData)
      setLoading(true)
        if(arg === 'GoBack'){
            resetAll(true)
        }
        else{
          axios
            .post(
              `${HOST}${API}register-user/`, 
              {
                phone_number: localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNo,
                name: arg.name,
                profession: arg.profession, 
                pincode: arg.pincode,
                user: userType    
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': localStorage.getItem('x-access-token')       
                }
              }
            )
            .then(async (res: any) => {
                if(res.data.data.data.resultCode === 0){
                  const newMembershipId = res.data.data.data.membershipId;
                  setMembershipID(newMembershipId);
                  await handleToGetMaxLimitCounts(newMembershipId);
                  setIsNewUser(false)
                }
                else{
                  setIsVerified(false)
                  setIsOtpVerified(false)
                  setInvalidCoupon(true)
                  setMsgPh('something went wrong')
                }
                if(res.status === 401 && res.messages.message === refresh_error_msg && count === 0){
                  refresh_access_token(res)
                  handleToUpdateAddDetails(arg)
                  count += 1
                }
                setLoading(false)
              })
            .catch((err: any) => {
                count = 0
                setIsVerified(false)
                setIsOtpVerified(false)
                setMsgPh('Something went wrong')
                setLoading(false)
            });
          }
    }

    const getTransactions = async () => {
      axios
        .get(
          `${HOST}${API}transaction-details/${userType}/${localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNo}/`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')       
            }
          }
        )
    .then((res: any) => {
      if(res.status === 200){
        console.log("res.data", res.data);
        setTransactions(res.data)
        setTransactionLoading(false)
      }
    })
    .catch((err: any) => {
      setTransactionLoading(false)
    });
  }

    const handleToUpdateStatus = (arg: any, message:any, orderId: string, id: string) => {
      // setLoading(true)
      // setOrderID(orderId)      
      //   setPaymentMessage(message)
      //   setPaymentStatus(arg)
      //   if(arg === "FAILURE"){
      //   }
      //   setIsSuccess(true)
      //   setLoading(false)
      setTransactionLoading(true)
      setLoading(true)
      setOrderID(orderId)
      setRazorID(id)
      if(!isMultiScan && arg !== 'RESPONSE_MESSAGE' && arg !== 'AMOUNTINVALID' && arg !== 'BLOCKUSER' && arg !== 'MEMBERINVALID') {
      axios //to get list of transactions
        .get(
          `${HOST}${API}transaction-details/${userType}/${localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNo}/`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')       
            }
          }
        )
        .then((res: any) => {
            if(res.status === 200){
              setTransactions(res.data)
              setTransactionLoading(false)
            }
          })
        .catch((err: any) => {
          if(err.status === 401 && err.messages.message === refresh_error_msg){
            refresh_access_token('')
          }
          setTransactionLoading(false)
        });
      }
       if (isMultiScan) {
        setPaymentMessage(message);
        setPaymentStatus(arg);
        setIsSuccess(true); 
        setTransactionLoading(false);
        setLoading(false);
        return;
      }
        setPaymentMessage(message)
        setPaymentStatus(arg)
        if(arg === "FAILURE"){
        }
        setIsSuccess(true)
        setLoading(false)
    }

    const handleToGetPreviousBankDetails = async() => {
      setLoading(true)
      // if(arg !== 'RESPONSE_MESSAGE' && arg !== 'AMOUNTINVALID' && arg !== 'BLOCKUSER' && arg !== 'MEMBERINVALID') {
      axios //to get list of transactions
        .get(
          `${HOST}${API}banking-details/${userType}/${localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNo}/`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')       
            }
          }
        )
        .then((res: any) => {
            if(res.status === 200){
              setPreviousBankDetails(res.data);
              if(res.data.length >0) {
                setPreviousBankDetailsFlag(true);
              }
              setLoading(false)
            }
          })
        .catch((err: any) => {
          setLoading(false)
          if(err.status === 401 && err.messages.message === refresh_error_msg){
            refresh_access_token('')
          }
        });
      // }
    }

    const previouslyAddedBankTransaction = (arg:any, type: any) => {
      setPreviousBankUUID([arg, type]);
      setBankDetailsSet(true);
    }

    const removePreiouslyAddedBanks = async(arg:any) => {
      setLoading(true)
      return axios
          .delete(
            `${HOST}${API}banking-details/`, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('x-access-token')
              },
              params: {
                user_type: userType,
                bank_uuid: arg
              },
            },
          )
          .then((res: any) => {
            setLoading(false)
            handleToGetPreviousBankDetails();
            return res;
          })
          .catch((err: any) => {
            setLoading(false)
            return err;
          });
    }

    const handleToProceedPayment = async(arg: any, amount:any, type:any, coupons:any) => {
      setCoupons(coupons);
      setIsMultiScan(Array.isArray(coupons) && coupons.length > 0);
      setMultiScanResults([]);
      if(type !== "AddNew") {
        await validateUserCmdi();
      }
      setLoading(true)
      setPreviousBankType(arg)
        if(arg === 'GoBack'){
            if(newUser === false){
              resetAll(true)
            }
            else{
              setIsNewUser(true)
            }
        } 
        // logic to convert credit to inr and points
        else{
          
          setAmount(amount)
          setIsProceeded(true)
          if(arg === 'paytm'){
            setPaymentType('paytm')
            setLoading(false)
          }
          else if(arg === 'bankAccount'){
            if(type === "AddNew") {
              setPreviousBankDetailsFlag(false);
              setLoading(false)
            }
            if(type !== "AddNew") {
              await handleToGetPreviousBankDetails();
            }
              setPaymentType('bank')
          }
          else if(arg === 'fccPoints'){
            setPaymentType('points')
            setLoading(false)
          } 
          // checkCode()  //commented for after payment prevent to call check coupon code api 
        }
        // setLoading(false)
    }

    const handleToUpdateBankDetails = (arg: any) => {
        setLoading(true)
        if(arg === 'GoBack'){
            // setLoading(false)
            setIsProceeded(false)
            checkCode();
        }
        else{ //api to send bank details locally
            
            setAccNo(arg.accNo)
            setIfsc(arg.ifsc)
            axios
            .post(
              `${HOST}${API}banking-details/`, 
              {
                phone_number: localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNo, 
                account_number: arg.accNo,
                ifsc_code: arg.ifsc, 
                bank_name: arg.bankName === 'Others' ? arg.otherBankName : arg.bankName,
                user_type: userType
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': localStorage.getItem('x-access-token')       
                }
              }
            )
            .then((res: any) => {
              if(res.data.message === 'Maximum accounts added' || res.data.message === 'IFSC Code invalid' || res.data.message === 'Record with same account number exists' || res.data.message === 'Error occurred while Saving Bank Account Details. Please Enter another bank account number and continue.'){
                setBankMsg(res.data.message)
              }
              else{
                setBankDetailsSet(true)
              }
              setLoading(false)
              })
            .catch((err: any) => {
              if(err.status === 401 && err.messages.message === refresh_error_msg && count === 0){
                refresh_access_token(err)
                handleToUpdateAddDetails(arg)
                count += 1
              }
              else{
                count = 0
                resetAll(true)
                setMsgPh('something went wrong')
              }
              setLoading(false)
            });    
        } 
        // setLoading(false)
    }

    
    const handleToUpdateSuccess = (arg: any) => {
      if(arg === 'GoBack'){
        resetAll(false)
    }
    let myVar:any;
    if(paymentType === "bank") {
    const timeout = async (i:any) =>{
      // setLoading(true)
      myVar = await new Promise((resolve)=> setTimeout(function(){ 
        // if(i === 6) {
        //   // setPaymentStatus("FAILURE")
        //   clearTimeout(myVar);
        //   return;
        // }
        // else 
        if(localStorage.getItem("tran_status") === "FAILURE") {
          clearTimeout(myVar);
          return;
        }
        else if(localStorage.getItem("tran_status") === "SUCCESS") {
          clearTimeout(myVar);
          return;
        }
        axios
        .post(
          `${HOST}${API}get-transaction-status/`, 
          {
            order_id: orderID,
            payment_type: paymentType,
            userType: userType,
            razor_transaction_id: razorID
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')       
            }
          }
        )
        .then((res: any) => {
            let status = res.data.response.status === "processed" || res.data.response.status === "SUCCESS" ? "SUCCESS" : 
            res.data.response.status === "queued" || res.data.response.status === "pending" || res.data.response.status === "processing" || res.data.response.status === "APPROVAL_PENDING" || res.data.response.status === "PENDING" || res.data.response.status === "QUEUED" || res.data.response.status === "RECEIVED" ? "PENDING" :
            "FAILURE";
            let statusMessage = res.data.response.statusMessage
            setFailUnbind(status);
            if(status !== "PENDING"){
              localStorage.setItem("tran_status", status)
              setPaymentStatus(status)
              setPaymentMessage(statusMessage)
              setConfirmedPayStatus(true)
            }
          })
        .catch((err: any) => {
        });
        if(i === 3) {
          clearTimeout(myVar);
          return;
        }
        resolve(i);
      }, 10000*i));
        // setLoading(false)
    }
    if(arg === "PENDING"){
      if(countCheck === true) {
        for(let i=1; i<=3; i++){
          timeout(i)
        }
      }
      setCount(false);
    }
    if(failUnbind === "SUCCESS"){
      return;
    }
    if(failUnbind === "FAILURE"){
      return;
    }
  }
  else {
    const timeout = async (i:any) =>{
      // setLoading(true)
      myVar = await new Promise((resolve)=> setTimeout(function(){ 
        // if(i === 6) {
        //   // setPaymentStatus("FAILURE")
        //   clearTimeout(myVar);
        //   return;
        // }
        // else 
        if(localStorage.getItem("tran_status") === "FAILURE") {
          clearTimeout(myVar);
          return;
        }
        else if(localStorage.getItem("tran_status") === "SUCCESS") {
          clearTimeout(myVar);
          return;
        }
        axios
        .post(
          `${HOST}${API}get-transaction-status/`, 
          {
            order_id: orderID,
            payment_type: paymentType,
            userType: userType
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')       
            }
          }
        )
        .then((res: any) => {
            let status = res.data.response.status
            let statusMessage = res.data.response.statusMessage
            setFailUnbind(status);
            if(status !== "PENDING"){
              localStorage.setItem("tran_status", status)
              setPaymentStatus(status)
              setPaymentMessage(statusMessage)
              setConfirmedPayStatus(true)
            }
          })
        .catch((err: any) => {
        });
        if(i === 3) {
          clearTimeout(myVar);
          return;
        }
        resolve(i);
      }, 10000*i));
        // setLoading(false)
    }
    if(arg === "PENDING"){
      if(countCheck === true) {
        for(let i=1; i<=3; i++){
          timeout(i)
        }
      }
      setCount(false);
    }
    if(failUnbind === "SUCCESS"){
      return;
    }
    if(failUnbind === "FAILURE"){
      return;
    }
  }
}

    const handleLogout = () => {
      setIsVerified(true)
      window.location.reload();
      localStorage.clear();
    }

    const handleBindCouponWithZeroAmount = async(arg:any , memberId : any) => {
      let data = {
        coupon_code : couponCode,
        user_type  : userType,
        membership_id : memberId,
        phone_number :  localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNo,
        user_latitude :  arg.lat,
        user_longitude :  arg.long,
        user_pincode :  arg.pincode,
        user_city : arg.city,
        product : pathParams[1]
      }
      await axios 
        .post(
          `${HOST}${API}bind-user-with-coupon/`, data ,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')       
            },
          }
        )
        .then(async (res: any) => {
            if(res.status === 200 || res.status === 201){
              setBindCodeData(res.data);
              await handleFetchZeroAmountCouponHistory()
            }
          })
        .catch((err: any) => {
          if(err.status === 401 && err.messages.message === refresh_error_msg){
            refresh_access_token('')
          }
        });
    }

    const handleGetLocationData = (city :any , pincode : any , lat :any, long : any , memberId:any) =>{
      setLocationData({
        lat : lat,
        long : long,
        pincode : pincode,
        city : city
      })
      handleBindCouponWithZeroAmount({ city , pincode , lat , long }, memberId )
    }

    const handleUpdateIsZeroStatus = () =>{
      setIsAmountZero(true)
    }


    const handleFetchZeroAmountCouponHistory = async() => {
      setTransactionLoading(true)
      // setLoading(true)
      await axios //to get list of transactions
        .get(
          `${HOST}${API}coupon-scan-history?phone_number=${localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNo}&redeem_amount=${amount}`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')       
            }
          }
        )
        .then((res: any) => {
            if(res.status === 200){
              setTransactions(res.data)
              setTransactionLoading(false)
            }
          })
        .catch((err: any) => {
          if(err.status === 401 && err.messages.message === refresh_error_msg){
            refresh_access_token('')
          }
          setTransactionLoading(false)
        });
        // setLoading(false)
    }

    // Reusable poller for a single order (3 attempts, every 10s), using handleToUpdateStatus
    const pollTransactionStatusForOrder = async (
      orderId: string,
      razorId: string | null,
      paymentTypeForOrder: string,
    ) => {
      for (let i = 1; i <= 3; i++) {
        await new Promise(resolve => setTimeout(resolve, 10000 * i));

        try {
          const res = await axios.post(
            `${HOST}${API}get-transaction-status/`,
            {
              order_id: orderId,
              payment_type: paymentTypeForOrder,
              userType: userType,
              ...(razorId ? { razor_transaction_id: razorId } : {}),
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('x-access-token'),
              },
            }
          );

          const rawStatus = res.data.response.status;
          const status: 'SUCCESS' | 'PENDING' | 'FAILURE' =
            rawStatus === 'processed' || rawStatus === 'SUCCESS'
              ? 'SUCCESS'
              : rawStatus === 'queued' ||
                rawStatus === 'pending' ||
                rawStatus === 'processing' ||
                rawStatus === 'APPROVAL_PENDING' ||
                rawStatus === 'PENDING' ||
                rawStatus === 'QUEUED' ||
                rawStatus === 'RECEIVED'
              ? 'PENDING'
              : 'FAILURE';

          const statusMessage = res.data.response.statusMessage;
          // Use functional update so we always work on the latest state
          setMultiScanResults(prev => {
            if (!prev || prev.length === 0) {
              return prev;
            }

            const updated = [...prev];
            const orderIndex = updated.findIndex(item => item.orderId === orderId);

            // If this order isn't in the list, don't overwrite anything
            if (orderIndex === -1) {
              return prev;
            }

            updated[orderIndex] = {
              ...updated[orderIndex],
              status,
              message: statusMessage,
            };

            return updated;
          });

          if (status !== 'PENDING') {
            break;
          }
        } catch (e) {
          console.error('get-transaction-status error for', orderId, e);
        }
      }
    };

    // for IDFY
  const getDocFile = (file: any, uploadFlag: any) => {
    setGetFile(file);
    setDocUploadFlag(uploadFlag)
  }

  const getSelfieFile = (file: any) => {
    setSelfieFile(file);
  }
  const uploadDocumentIdfy = async () => {
    setDocUploadLoading(true)
    setLoading(true)
    let formdata = new FormData();
    formdata.append("img", getFile);
    formdata.append("membership_no", membershipID);
    return axios
      .post(
        `${HOST}apis/v.1.0/idfy/check-document/`,
        formdata,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': localStorage.getItem('x-access-token')
          },
        }
      )
      .then(async (res: any) => {
        console.log(res.data, "res")
        const data = res.data;
        setKycDocStatus(data)
        if (data.status === true) {
          setIsSelfiePage(true);
        }
        setDocUploadLoading(false)
        setLoading(false)
        setFaceLiveMessage('')
        return res
      })
      .catch((error: any) => {
        setDocUploadLoading(false)
        setLoading(false)
        setFaceLiveMessage('')
        return error
      });
  }

  const documentIdfyStatus = async (arg: any, timer?: any) => {
    //  This is for future use
    // if (!timer) {
    // if(docUploadLoadingFlag === true) {
    //   setDocUploadLoading(false)
    // } else {
    setDocUploadLoading(true)
    // }
    setLoading(true)
    // }
    return axios
      .get(
        `${HOST}apis/v.1.0/idfy/check-status/?membership_no=${arg}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('x-access-token')
          }
        }
      )
      .then((res: any) => {
        const data = res.data;
        setIdfyDocData(data)
        if (data.status === "Pending") {
          setIdfyTranStatus("Kyc verification is in process, Please try again after sometime!")
          setIsOnfidoPage(true)
          setIsSelfiePage(false);
        } else if (data.status === "Rejected" && (data.attempt === 2 || data.attempt > 2)) {
          setRejectKYC(true);
          clearTimeout(interval);
          setIsOnfidoPage(true)
          setLoading(false);
          setIsSelfiePage(false);
          localStorage.setItem("kyc_status", data.status)
        } else if (data.status === "Rejected" && (data.attempt < 3)) {
          setIdfyTranStatus('Your Kyc is rejected, Please try Again!')
          clearTimeout(interval);
          setLoading(false);
          setIsOnfidoPage(true);
          setIsSelfiePage(false);
          localStorage.setItem("kyc_status", data.status)
        } else if (data.status === "Approved") {
          clearTimeout(interval);
          setIsOnfidoPage(false);
          setIsSelfiePage(false);
          setLoading(false);
          localStorage.setItem("kyc_status", data.status)
        }

        setKycStatus(data.status)
        setKycStatusAttempt(data.attempt)
        setDocUploadLoading(false)
        // setLoading(false)
        return res;
      })
      .catch((error: any) => {
        setDocUploadLoading(false)
        setLoading(false)
        return error
      });
  }

  const faceCompare = async () => {
    localStorage.removeItem("kyc_status");
    setDocUploadLoading(true)
    setLoading(true)
    let formdata = new FormData();
    formdata.append("img", getSelfie);
    formdata.append("membership_no", membershipID);
    return axios
      .post(
        `${HOST}apis/v.1.0/idfy/face-compare-live/`, formdata,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('x-access-token')
          }
        }
      )
      .then(async (res: any) => {
        const data = res.data;
        setDocUploadLoading(false)
        setLoading(false)
        if (data.status === "Rejected") {
          setIsOnfidoPage(true);
          setIsSelfiePage(false);
          await documentIdfyStatus(membershipID);
          return;
        } else if (data.status === "Approved") {
          setIsSelfiePage(false);
          setIsOnfidoPage(false)
        } else if (data.status === "Pending") {
          const docidfyStatus = await documentIdfyStatus(membershipID);
          const idfyData = docidfyStatus.data
          setDocUploadLoading(false)
          setLoading(false)
          // set interval if kyc status is pending
          const timeout = async (i: any) => {
            setLoading(true);
            // let myVar: any;
            interval = await new Promise((resolve) => setTimeout(function () {
              if (localStorage.getItem("kyc_status") === "Rejected") {
                setLoading(false);
                clearTimeout(interval);
                return;
              }
              else if (localStorage.getItem("kyc_status") === "Approved") {
                setLoading(false);
                clearTimeout(interval);
                return;
              }
              documentIdfyStatus(membershipID, "timer");
              if (i === 3) {
                setLoading(false);
                clearTimeout(interval);
                return;
              }
              resolve(i);
            }, 10000 * i));
          }
          if (idfyData.status === "Pending") {
            setLoading(false);
            if (idfyCountCheck === true) {
              for (let i = 1; i <= 3; i++) {
                timeout(i)
              }
            }
            setIdfyCount(false);
          }//end here

          if (idfyData.status === "Approved") {
            setIsOnfidoPage(false);
            setIsSelfiePage(false);
            setKycMessageVerified("Yes")
          }
        }
        // setIsOnfidoPage(false) //added for transaction after idfy
        // ---
        return res;
      })
      .catch(async (error: any) => {
        const errRes = error.response;
        setSelfieDocStatus(errRes.data)
        // Added for face liveness message
        if(errRes.status === 400) {
          if(errRes.data.status === "Rejected") {
            setFaceLiveMessage(errRes.data.message)
          }
        }
        if (errRes.data.status === false) {
          setIsOnfidoPage(true);
          setIsSelfiePage(false);
          await checKYCStatus();
          await documentIdfyStatus(membershipID);
        }
        setDocUploadLoading(false)
        setLoading(false)
        return error
      });
  }
  // end here
 
  const handleHistoryOpen = () => {
    setViewHistory(true);
    GetTransactionHistory('', '', '', '');
  }

  const GetTransactionHistory = (arg: any, search: any, fromDate: string, toDate: string, offset: number = 0, append: boolean = false) => {
    if (cancel !== undefined && !append) {
      cancel();
    }
    
    if (!append) {
      setTransactionHistoryLoading(true)
      setTransactionOffset(0);
    } else {
      setLoadingMoreTransactions(true);
    }
    
    // Build query parameters - Using limit=1 for testing with 2 records
    // Change limit=1 to limit=10 for production
    let queryString = `limit=10&offset=${offset}`;
    if (fromDate && toDate) {
      queryString = `createddate__date__range=${fromDate},${toDate}&${queryString}`;
    }
    if (search) {
      queryString += `&search=${search}`;
    }
    
    return axios
        .get(
            `${HOST}apis/v.1.0/saathi/transaction/?${queryString}`,
            {
              cancelToken: new CancelToken(function executor(c: any) {
                if (!append) {
                  cancel = c;
                }
              }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem('x-access-token')       
                }
            },
        )
        .then((res: any) => {
            let Data = res.data.results;
            const hasNext = res.data.next !== null && res.data.next !== undefined;
            
            if (append) {
              // Append new data to existing data
              setTransactionHistoryData((prevData: any) => {
                if (Array.isArray(prevData) && Array.isArray(Data)) {
                  return [...prevData, ...Data];
                }
                return Data;
              });
              setLoadingMoreTransactions(false);
            } else {
              // Replace data
              setTransactionHistoryData(Data);
              setTransactionHistoryLoading(false);
            }
            
            setHasMoreTransactions(hasNext);
            setTransactionOffset(offset + Data.length);
        })
        .catch((err: any) => {
            setTransactionHistoryLoading(false);
            setLoadingMoreTransactions(false);
            return err;
        });
}

  const handleToGetMaxLimitCounts = async (membershipIdParam?: string) => {
    return axios
      .post(
        `${HOST}${API}get-max-limit-counts/`,
        {
          membership_id: membershipIdParam || membershipID
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      )
      .then((res: any) => {
        const data: MaxCountResponse = res.data;
        if (data) {
          setMaxLimitCounts(data);
          
        }
        return res;
      })
      .catch((err: any) => {
        return err;
      });
  }
    
      const{ banner, subBanner } = props;
      const heading = "Location Disabled !!"
      const content = "Please allow location services"
      const transactionList = ["ALL", 'Last 10 Txn', 'Last 7 Days', 'Current Month']
        return (
          RejectKYC ?
          <ErrorMessage addClass='app3' />
          :
          localStorage.getItem("error_throw") === "yes" ?
          <ErrorMessage />
            :
          locationBlocked ? <WarningModal heading={heading} content={content} />
            :
            <div className='home popup_logout'>
                {
                    loading &&
                    <div className='main-loader'>
                      <CircularProgress />
                    </div>
                }
                {localStorage.getItem("IS_LOGIN") === "yes" &&
                <div className={
                  isProceeded && !isSuccess && paymentType==='bank' && !loading && !couponValid && !bankDetailsSet &&!isOnfidoPage ? "logout_btn_paytm button top" : 
                  isSuccess && !confirmedPayStatus && !loading && !couponValid && paymentStatus !== "FAILURE" && paymentStatus !== "SUCCESS" && paymentStatus !== "PENDING" ? "logout_btn_paytm button top" : 
                  isSuccess && confirmedPayStatus && !loading && !couponValid && paymentStatus !== "FAILURE" && paymentStatus !== "SUCCESS" && paymentStatus !== "PENDING" ? "logout_btn_paytm button top" : 
                  loading ? "logout_btn_paytm button loader" : 
                  bankDetailsSet && !isSuccess && paymentType==='bank' && !couponValid ? "logout_btn_paytm button loader" : 
                  isProceeded && !isSuccess && paymentType==='points' && !couponValid ? "logout_btn_paytm button loader" : 
                  isProceeded && !isSuccess && paymentType==='paytm' && !couponValid ? "logout_btn_paytm button loader" : isAmountZero ? 'logout_btn_paytm button loader' : isOnfidoPage ? "logout_btn_paytm button kyc_logout" : "logout_btn_paytm button"}>
                  <button className="logout_btn" onClick={handleLogout}><PowerSettingsNewIcon /> Logout</button>
                </div>
                }

                  {localStorage.getItem("IS_LOGIN") === "yes" && !loading &&
                  <div className={isProceeded && !isSuccess && paymentType === 'bank' && !loading && !couponValid && !bankDetailsSet && !isOnfidoPage ? "view_history_btn history_top" :
                    isSuccess && !confirmedPayStatus && !loading && !couponValid && paymentStatus !== "FAILURE" && paymentStatus !== "SUCCESS" && paymentStatus !== "PENDING" ? "view_history_btn history_top" :
                    isSuccess && confirmedPayStatus && !loading && !couponValid && paymentStatus !== "FAILURE" && paymentStatus !== "SUCCESS" && paymentStatus !== "PENDING" ? "view_history_btn history_top" :
                      bankDetailsSet && !isSuccess && paymentType === 'bank' && !couponValid ? "view_history_btn loader" :
                      isProceeded && !isSuccess && paymentType === 'points' && !couponValid ? "view_history_btn loader" :
                        isProceeded && !isSuccess && paymentType === 'paytm' && !couponValid ? "view_history_btn loader" : isAmountZero ? 'view_history_btn loader' : isOnfidoPage ? "view_history_btn kyc_logout_history" : "view_history_btn"}>
                    <button className="logout_btn" onClick={handleHistoryOpen}>Txn History</button>
                  </div>
                  }

                  {localStorage.getItem("IS_LOGIN") === "yes" && !loading && (
                  <TransactionHistoryFilter viewHistory={viewHistory} setViewHistory={setViewHistory} transactionList={transactionList} transactionHistoryLoading={transactionHistoryLoading} transactionHistoryData={transactionHistoryData} transactionTab={transactionTab} setTransactionTab={setTransactionTab} GetTransactionHistory={GetTransactionHistory} hasMoreTransactions={hasMoreTransactions} loadingMoreTransactions={loadingMoreTransactions} transactionOffset={transactionOffset} />
                  )}

                {/* Added for future use
                 {localStorage.getItem("IS_LOGIN") === "yes" && !loading &&
                isOnfidoPage ?
                skipStatus ?
                  <Typography style={{ color: "red" }}>The kyc is mandatory after 2 transactions!</Typography> :
                  <div className="logout_btn_paytm2 button">
                  <button className="logout_btn" disabled={skipStatus ? true : false} onClick={() => (setIsOnfidoPage(false), setIsSelfiePage(false))}>
                    Skip kyc verification</button>
                  </div>
                :
                null
                } */}

                {
                  couponValid && localStorage.getItem("IS_LOGIN") === "yes" &&
                  <VerifyNumber msgPh={msgPh} scan={codeScanStatus} codeScanStatusCode={codeScanStatusCode} handleToUpdateVerified={handleToUpdateNumber} banner={banner} subBanner={subBanner} />
                }
                { 
                    !isVerified && !loading && paymentStatus !== 'AMOUNTINVALID' && paymentStatus !== 'MEMBERINVALID' && paymentStatus !== 'BLOCKUSER' && paymentStatus !== 'RESPONSE_MESSAGE' && 
                    !localStorage.getItem("IS_LOGIN") &&
                    <VerifyNumber msgPh={msgPh} scan={codeScanStatus} codeScanStatusCode={codeScanStatusCode} handleToUpdateVerified={handleToUpdateNumber} banner={banner} subBanner={subBanner} />
                }

                {
                    !isOtpVerified && isVerified && !loading && canRedeem && !localStorage.getItem("IS_LOGIN") &&
                    <VerifyOtp handleToUpdateOtp={handleToUpdateOTP} msg={otpMessage} banner={banner} subBanner={subBanner} />
                }

                {
                    isOtpVerified && isNewUser &&  !loading && paymentStatus !== 'AMOUNTINVALID' && paymentStatus !== 'MEMBERINVALID' && paymentStatus !== 'BLOCKUSER' && paymentStatus !== 'RESPONSE_MESSAGE' && paymentStatus !== 'NOT POSSIBLE' &&
                    <CustomerDetails division={userType} handleToUpdateAdded={handleToUpdateAddDetails}
                    banner={banner} />
                }

                {
                    !isNewUser && !isProceeded && !loading && paymentStatus !== 'NOT POSSIBLE' && isOtpVerified && !couponValid && is0Point &&
                    <Success paymentMessage={paymentMessage} transactions={transactions} paymentStatus={paymentStatus} 
                    handleToUpdateTransactionOK={handleToUpdateSuccess} transactionLoading={transactionLoading} amount={amount} isZero={"Yes"}  memberId={membershipID} handleGetLocationData = {handleGetLocationData}  handleUpdateIsZeroStatus={handleUpdateIsZeroStatus} coupons={coupons} multiScanResults={multiScanResults} />
                }
                
                {
                    !isNewUser && !isProceeded && !loading && paymentStatus !== 'NOT POSSIBLE' && isOtpVerified && !couponValid && !is0Point &&
                    <TransactionDetails conversions={conversions} redeemPoints={redeemable} amount={amount} 
                    userType={userType} handleToProceed={handleToProceedPayment} banner={banner} maxLimitCounts={maxLimitCounts} handleToGetMaxLimitCounts={handleToGetMaxLimitCounts} checkCouponCode={checkCouponCode} initialCouponCode={couponCode} brand={pathParams[1]}/>
                }

                {
                    isProceeded && !isSuccess && paymentType==='paytm' && !loading && !couponValid && !isOnfidoPage &&
                    <Payouts type="wallet" phoneNumber={phoneNo} amount={amount} coupon={couponCode} user={userType} 
                    membershipID={membershipID} handleToUpdateStatus={handleToUpdateStatus} prevBankUUID={prevBankUUID} coupons={coupons} pollTransactionStatusForOrder={pollTransactionStatusForOrder} setMultiScanResults={setMultiScanResults} getTransactions={getTransactions} />
                }

                {
                    isProceeded && !isSuccess && paymentType==='bank' && !loading && !couponValid && !bankDetailsSet && !isOnfidoPage &&
                    // !previousBankDetailsFlag && 
                    <BankDetails bankMsg={bankMsg} handleToUpdatePayment={handleToUpdateBankDetails}
                    handleToProceed={handleToProceedPayment} previousBankDetails={previousBankDetails} amount={amount} 
                    prevBankType={prevBankType} previouslyAddedBankTransaction={previouslyAddedBankTransaction} 
                    removePreiouslyAddedBanks={removePreiouslyAddedBanks}
                    /> 
                }

                {/* {
                    isProceeded && !isSuccess && paymentType==='bank' && !loading && !couponValid && !bankDetailsSet && previousBankDetailsFlag &&
                    <PreviousBankDetails 
                    handleToProceed={handleToProceedPayment} previousBankDetails={previousBankDetails} amount={amount} 
                    prevBankType={prevBankType} previouslyAddedBankTransaction={previouslyAddedBankTransaction} 
                    removePreiouslyAddedBanks={removePreiouslyAddedBanks} />
                } */}

                {
                    bankDetailsSet && !isSuccess && paymentType==='bank' && !loading && !couponValid && !isOnfidoPage &&
                    <Payouts type="bank" phoneNumber={phoneNo} amount={amount} coupon={couponCode} user={userType} 
                    membershipID={membershipID} accNo={accNo} ifsc={ifsc} handleToUpdateStatus={handleToUpdateStatus}
                    prevBankUUID={prevBankUUID}  coupons={coupons} pollTransactionStatusForOrder={pollTransactionStatusForOrder} setMultiScanResults={setMultiScanResults} getTransactions={getTransactions} />
                }

                {
                    isProceeded && !isSuccess && paymentType==='points' && !loading && !couponValid && !isOnfidoPage &&
                    <Payouts type="points" user={userType} membershipID={membershipID} coupon={couponCode} phoneNumber={phoneNo} 
                    amount={amount}  handleToUpdateStatus={handleToUpdateStatus} prevBankUUID={prevBankUUID} coupons={coupons}  pollTransactionStatusForOrder={pollTransactionStatusForOrder} setMultiScanResults={setMultiScanResults} getTransactions={getTransactions} />
                }

                {
                    isSuccess && !confirmedPayStatus && !loading && !couponValid && !isOnfidoPage &&
                    <Success paymentMessage={paymentMessage} transactions={transactions} paymentStatus={paymentStatus} 
                    handleToUpdateTransactionOK={handleToUpdateSuccess} transactionLoading={transactionLoading} amount={amount} isZero={"No"}  memberId={membershipID} handleGetLocationData = {handleGetLocationData} handleUpdateIsZeroStatus = {handleUpdateIsZeroStatus} coupons={coupons} multiScanResults={multiScanResults} />
                }

                {
                    isSuccess && confirmedPayStatus && !loading && !couponValid && !isOnfidoPage &&
                    <Success paymentMessage={paymentMessage} transactions={transactions} paymentStatus={paymentStatus} 
                    handleToUpdateTransactionOK={handleToUpdateSuccess} transactionLoading={transactionLoading} amount={amount} isZero={"No"}  memberId={membershipID}  handleGetLocationData = {handleGetLocationData} handleUpdateIsZeroStatus = {handleUpdateIsZeroStatus}  coupons={coupons} multiScanResults={multiScanResults}/>
                }

                {
                  isOnfidoPage && !isSelfiePage &&
                  !loading && !couponValid && validateUser &&
                  <OnfidoPageptr
                    membershipID={membershipID}
                    uploadDocumentIdfy={uploadDocumentIdfy}
                    docUploadLoading={docUploadLoading}
                    getDocFile={getDocFile}
                    idfyDocData={idfyDocData}
                    idfyTranStatus={idfyTranStatus}
                    kycStatusFlag={KycStatus}
                    KycStatusAttempt={KycStatusAttempt}
                    setKycStatus={setKycStatus}
                    kycDocStatus={kycDocStatus}
                    selfieDocStatus={selfieDocStatus}
                    banner={banner}
                  />
                }

                {
                  isSelfiePage && !loading && !couponValid && validateUser &&
                  <ImageUploadPage setIsOnfidoPage={setIsOnfidoPage} membershipID={membershipID}
                    faceCompare={faceCompare} getSelfieFile={getSelfieFile} faceLiveMessage={faceLiveMessage}
                    banner={banner} idfyDocData={idfyDocData} />
                }

                <Footer />

            </div>             
        )
    }

export default Main